import { RootState } from "reducers/store"
import { isDev } from 'app/general'
import { User } from "firebase/auth"

export const optionsMaker = async (method: string, body: any, getState: () => RootState, dispatch: any, passedUser?: User) => {

  let accessToken = getState().userReducer.token
  const tokenLoading = getState().userReducer.tokenLoading
  let user = getState().userReducer.user

  if (!passedUser) {
    if (!accessToken) {
       isDev && console.log("CAN NOT GET ACCESS TOKEN")
      return null
    }
    if (tokenLoading) {
       isDev && console.log("tokenIsLoading")
      return null
    }
    if (!user) {
       isDev && console.log("NO USER OBJECT. LOGOUT")
      return null
    }
  } else {
    accessToken = await passedUser.getIdToken(true)
  }

  const options = {
    method: method,
    headers: {
      Authorization: 'Bearer ' + accessToken,
      'Content-Type': 'application/json',
    },
  }

  if (body) {
    return { ...options, body: JSON.stringify(body) }
  }

  return options
}
